<div id="verifiedpnl" class="verifiedpnl">
  <div class="verified-inner">
    <div class="header w-100">
      <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm navbar fixed-top">
        <div class="container">
          <div class="logo hide-mobile">
            <a class="navbar-brand" routerLink="/dashboard">
              <img src="/assets/images/botlogo.png" alt="logo" width="60">
            </a>
          </div>
          <div class="logo show-mobile ml-2">
            <a class="navbar-brand mx-0" routerLink="/dashboard">
              <img src="/assets/images/bot-logo-mobile.png" alt="logo" width="15">
            </a>
          </div>
          <div class="text-end">
            <span class="ft-14 text-light bg-darkgrey">
              <a href="https://aliceblueonline.com/open-account-fill-kyc-request-call-back/"
                target="_blank"
              class="bg-darkblue text-light p-2 me-3 text-decoration-none rounded">Open an Account</a>
            </span>
            <span class="ft-24 text-success"><img src="./assets/images/verified.png" alt="" width="40"
            class="pe-2 mob-width">VERIFIED</span>
          </div>
        </div>
      </nav>
    </div>
    <div class="inner-class bg-img">
      <div class="container pt-3">
        @if (datapresent == true) {
          <div class="py-5 zindex">
            <div class="name-block py-3">
              <div class="row mx-0">
                <div class="col-md-6">
                  <div class="ft-24">
                    <span
                      class="rounded-circle border text-light text-center border rounded-circle block">
                      {{objectArray?.charAt(0)}}{{objectArray?.charAt(1)}}
                    </span>
                    @if (nametype == 'masked') {
                      <span class="ps-2">
                        {{objectArray |slice:0:3 }} {{maskname}}
                        <!-- {{maskname}} -->
                      </span>
                    }
                    @if (nametype == 'fullName') {
                      <span class="ps-2">
                        {{objectArray}}
                      </span>
                    }
                  </div>
                </div>
                <div class="col-md-6 text-end mob-start">
                  <div class="text-secondary ft-12">
                    <!-- <p class="text-darkgrey mb-0">
                  Net realised P&L</p> -->
                  <p class="mb-0">Since {{datefrom | date : 'dd-MM-yyyy'}} till {{dateto | date : 'dd-MM-yyyy'}}</p>
                  <!-- <p class="text-danger mb-0 fw-bold">-154</p> -->
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="pnl-block py-2 border-bottom py-4">
              <!-- <div [ngClass]="hideHeatmap ? 'calendar-heatmap' : 'calendar-heatmap-none'">
              <svg class="width-hgt">
                <rect *ngFor="let day of heatmapCalendarFinalArray" class="day-cell" width="15" height="15" cursor="pointer" border-radius="2px" [attr.fill]="day?.fill" [attr.date]="day.date" [attr.x]="day?.x" [attr.y]="day?.y" [ngbTooltip]="tooltipContent" container="body" triggers="manual" #t="ngbTooltip" (mouseenter)="mouseEnter(t, day.date, day.pnl)" (mouseleave)="mouseLeave(t)" (click)="clickEvent(day)"></rect>
                <text *ngFor="let month of filterYearMonthArray" class="month-name text-center" style="font-size:12px" [attr.x]="month.x" [attr.y]="month.y">{{month.month}}</text>
              </svg>
            </div> -->
            <div class="d-flex justify-content-center">
              <div>
                <div id="verified-calendar"></div>
              </div>
            </div>
            <!-- <ng-template #tooltipContent>
            <span *ngIf="eventPnl != undefined" class="ft-12">Gross Realised P&L On:
            {{tooltipDate}}: {{eventPnl}}</span>
            <span *ngIf="eventPnl == undefined" class="ft-12">No data on: {{tooltipDate}}</span>
          </ng-template> -->
        </div>
      </div>
      <div class="dropdown col-md-12 pt-5 text-center">
        <form [formGroup]="profitLossForm" >
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs justify-content-center">
            @if (this.equitydata) {
              <li [ngbNavItem]="0">
                <p class="tex-center">
                  @if (equitydata) {
                    <a ngbNavLink class="px-5 border mr-4 mb-2"
                      (click)="submitProfitNLoss(segments[0])">
                      <span class="p-2">
                        <span class="text-secondary ft-14 text-center">
                          {{equityname}}
                        </span>
                        <br>
                          <p class="text-center cus-pad">
                            <span [ngClass]="equitytable < 0 ? 'text-danger' : 'text-success'">
                              ₹ {{equitytable |number:'1.0-3'}}
                            </span>
                          </p>
                        </span>
                      </a>
                    }
                  </p>
                  <ng-template ngbNavContent>
                    <!--Search Field-->
                    @if (displayTrades == 'true' && equityrow.length > 0 || searchTextA && searchTextA !== '') {
                      <div class="row mt-3 mb-0"
                        >
											<!-- *ngIf="equityrow.length > 0 || (searchTextA && searchTextA !== '') -->
											<div class="col-md-10 col-6"></div>
											<div class="col-md-2 col-6">
												<input class="form-control ft-12" type="text"
													(input)="applyFilterA($event)" id="searchInputA" autocomplete="off"
                            #searchInputA placeholder="Search" />
                          </div>
                        </div>
                      }
                      @if (equityrow) {
                        <div class="pt-3 mobile-padding">
                          <div class="table">
                            @if (!anoSearchResults && equityrow.length > 0) {
                              <div class="table-inner hide-mobile"
                                >
                                <table class="table-cus1 table-layout">
                                  <tr class="border-top text-start">
                                    <!-- <th class="text-center text-secondary border-end"
                                    *ngFor="let header of equityheader">
                                  {{getheader(header) |titlecase}}</th> -->
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2" sortable="0"
                                    (click)="equityTableSorting(0)"
                                    (mouseenter)="currentHoveredColumn = '0'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-2"></div>
                                      <div class="col-8 text-center">
                                        <span>Symbol</span>
                                      </div>
                                      <div class="col-2">
                                        @if (SortingDirections[0] !== 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                          <span
                                            ><img
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[0] === 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                          <span
                                            ><img
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2"
                                    sortable="1"
                                    (click)="equityTableSorting(1)"
                                    (mouseenter)="currentHoveredColumn = '1'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-12 text-center">
                                        <span>Quantity</span>
                                        @if (SortingDirections[1] !== 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[1] === 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2"
                                    sortable="2"
                                    (click)="equityTableSorting(2)"
                                    (mouseenter)="currentHoveredColumn = '2'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-12 text-center">
                                        <span>Buy Date</span>
                                        @if (SortingDirections[2] !== 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[2] === 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2"
                                    sortable="3"
                                    (click)="equityTableSorting(3)"
                                    (mouseenter)="currentHoveredColumn = '3'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-12 text-center">
                                        <span>Buy Average</span>
                                        @if (SortingDirections[3] !== 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[3] === 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2"
                                    sortable="4"
                                    (click)="equityTableSorting(4)"
                                    (mouseenter)="currentHoveredColumn = '4'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-12 text-center">
                                        <span>Buy Value</span>
                                        @if (SortingDirections[4] !== 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[4] === 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2"
                                    sortable="5"
                                    (click)="equityTableSorting(5)"
                                    (mouseenter)="currentHoveredColumn = '5'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-12 text-center">
                                        <span>Sell Date</span>
                                        @if (SortingDirections[5] !== 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[5] === 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2"
                                    sortable="6"
                                    (click)="equityTableSorting(6)"
                                    (mouseenter)="currentHoveredColumn = '6'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-12 text-center">
                                        <span>Sell Average</span>
                                        @if (SortingDirections[6] !== 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[6] === 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2"
                                    sortable="7"
                                    (click)="equityTableSorting(7)"
                                    (mouseenter)="currentHoveredColumn = '7'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-12 text-center">
                                        <span>Sell Value</span>
                                        @if (SortingDirections[7] !== 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[7] === 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                  <th scope="col"
                                    class="text-center cursor-pointer text-secondary border-end col-2"
                                    sortable="8"
                                    (click)="equityTableSorting(8)"
                                    (mouseenter)="currentHoveredColumn = '8'"
                                    (mouseleave)="currentHoveredColumn = null">
                                    <div class="row">
                                      <div class="col-12 text-center">
                                        <span>Profit / Loss</span>
                                        @if (SortingDirections[8] !== 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-up.png" alt=""
                                          width="10"></span>
                                        }
                                        @if (SortingDirections[8] === 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                          <span
                                            ><img style="position: absolute;top: 8px;right: 2px;"
                                            src="./assets/images/arrow-down.png" alt=""
                                          width="10"></span>
                                        }
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                @for (average of equityrowData; track average) {
                                  <tr
                                    class="shadow-none table-row">
                                    <td class="border-end text-center"> {{average[0]}}
                                    </td>
                                    <td class="border-end text-center"> {{average[1]}}
                                    </td>
                                    <td class="border-end text-center"> {{average[2]}}
                                    </td>
                                    <td class="border-end col-2 text-center"> {{average[3]}}
                                    </td>
                                    <td class="border-end text-center"> {{average[4]}}
                                    </td>
                                    <td class="border-end col-2 text-center"> {{average[5]}}
                                    </td>
                                    <td class="border-end text-center"> {{average[6]}}
                                    </td>
                                    <td class="border-end text-center"> {{average[7]}}
                                    </td>
                                    <!-- <td class="border-end col-2 text-center"
                                    *ngIf="equityname !== 'Equity'"
                                    [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                  {{average[8]}}</td>
                                  <td class="border-end col-2 text-center"
                                  *ngIf="equityname === 'Equity'"> {{average[8]}}</td> -->
                                  <td class="border-end text-center"
                                    [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                  {{average[8]}}</td>
                                </tr>
                              }
                            </table>
                          </div>
                        }
                        <div class="show-mobile">
                          <div class="py-2 overflow-height">
                            @for (average of equityrowData; track average) {
                              <div class="card rounded-0 py-2 ps-0 border-0 border-bottom"
                                >
                                <div class="card-inner px-2 ps-0">
                                  <!--*ngIf="equityname =='Equity'" ;else other -->
                                  <div class="row mx-0">
                                    <div class="col-12 ps-0 py-1 text-start">
                                      <div class="heading ft-16">
                                        {{average[0]}}
                                      </div>
                                    </div>
                                    <!-- <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div class="col-4 px-0 ft-14 text-secondary text-start">
                                        ISIN :
                                      </div>
                                      <div class="col-8 px-0 ft-14 text-darkgrey text-start">
                                        {{average[1]}}
                                      </div>
                                    </div>
                                  </div> -->
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-5 px-0 ft-14 text-secondary text-start">
                                        Buy Avg:
                                      </div>
                                      <div
                                        class="col-7 px-0 ft-14 text-darkgrey text-start">
                                        {{average[3]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-6 px-0 ft-14 text-secondary text-start">
                                        Buy Date:
                                      </div>
                                      <div
                                        class="col-6 px-0 ft-14 text-darkgrey text-end">
                                        {{average[2]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-5 px-0 ft-14 text-secondary text-start">
                                        Qty :
                                      </div>
                                      <div
                                        class="col-7 px-0 ft-14 text-darkgrey text-start">
                                        {{average[1]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-6 px-0 ft-14 text-secondary text-start">
                                        Buy Value:
                                      </div>
                                      <div
                                        class="col-6 px-0 ft-14 text-darkgrey text-end">
                                        {{average[4]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-6 px-0 ft-14 text-secondary text-start">
                                        Sell Value:
                                      </div>
                                      <div
                                        class="col-6 px-0 ft-14 text-darkgrey text-start">
                                        {{average[7]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-6 px-0 ft-14 text-secondary text-start">
                                        Sell Date:
                                      </div>
                                      <div
                                        class="col-6 px-0 ft-14 text-darkgrey text-end">
                                        {{average[5]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-5 px-0 ft-14 text-secondary text-start">
                                        Sell Avg:
                                      </div>
                                      <div
                                        class="col-7 px-0 ft-14 text-darkgrey text-start">
                                        {{average[6]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-5 px-0 ft-14 text-secondary text-start">
                                        Profit :
                                      </div>
                                      <div class="col-7 px-0 ft-14 text-darkgrey text-start"
                                        [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                        {{average[8]}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <!-- <div class="show-mobile">
                      <div class="py-2 overflow-height">
                        <div class="card rounded-0 py-2 ps-0 border-0 border-bottom"
                          *ngFor="let average of equityrowData">
                          <div class="card-inner px-2 ps-0"
                            *ngIf="equityname =='Equity'">-->
                            <!-- ;else other -->
                            <!--<div class="row mx-0">
                            <div class="col-12 ps-0 py-1 text-start">
                              <div class="heading ft-16">
                                {{average[0]}}
                              </div>
                            </div>
                            <div class="col-6 px-0 py-1">
                              <div class="row mx-0">
                                <div
                                  class="col-4 px-0 ft-14 text-secondary text-start">
                                  Symbol :
                                </div>
                                <div
                                  class="col-8 px-0 ft-14 text-darkgrey text-start">
                                  {{average[0]}}
                                </div>
                              </div>
                            </div>
                            <div class="col-6 px-0 py-1">
                              <div class="row mx-0">
                                <div
                                  class="col-5 px-0 ft-14 text-secondary text-start">
                                  Buy Avg:
                                </div>
                                <div
                                  class="col-7 px-0 ft-14 text-darkgrey text-end">
                                  {{average[3]}}
                                </div>
                              </div>
                            </div>
                            <div class="col-6 pe-0 py-1">
                              <div class="row mx-0">
                                <div
                                  class="col-6 px-0 ft-14 text-secondary text-start">
                                  Buy Date:
                                </div>
                                <div
                                  class="col-6 px-0 ft-14 text-darkgrey text-end">
                                  {{average[2]}}
                                </div>
                              </div>
                            </div>
                            <div class="col-6 px-0 py-1">
                              <div class="row mx-0">
                                <div
                                  class="col-5 pe-0 ft-14 text-secondary text-start">
                                  Qty :
                                </div>
                                <div
                                  class="col-7 px-0 ft-14 text-darkgrey text-end">
                                  {{average[1]}}
                                </div>
                              </div>
                            </div>
                            <div class="col-6 px-0 py-1">
                              <div class="row mx-0">
                                <div
                                  class="col-6 px-0 ft-14 text-secondary text-start">
                                  Buy Value:
                                </div>
                                <div
                                  class="col-6 px-0 ft-14 text-darkgrey text-start">
                                  {{average[4]}}
                                </div>
                              </div>
                            </div>
                            <div class="col-6 px-0 py-1">
                              <div class="row mx-0">
                                <div
                                  class="col-6 px-0 ft-14 text-secondary text-start">
                                  Sell Date:
                                </div>
                                <div
                                  class="col-6 px-0 ft-14 text-darkgrey text-end">
                                  {{average[5]}}
                                </div>
                              </div>
                            </div>
                            <div class="col-6 px-0 py-1">
                              <div class="row mx-0">
                                <div
                                  class="col-5 px-0 ft-14 text-secondary text-start">
                                  Sell Avg:
                                </div>
                                <div
                                  class="col-7 px-0 ft-14 text-darkgrey text-start">
                                  {{average[6]}}
                                </div>
                              </div>
                            </div>
                            <div class="col-6 px-0 py-1">
                              <div class="row mx-0">
                                <div
                                  class="col-6 px-0 ft-14 text-secondary text-start">
                                  Sell Value:
                                </div>
                                <div
                                  class="col-6 px-0 ft-14 text-darkgrey text-end">
                                  {{average[7]}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-template #other>
                          <div class="card-inner px-2 ps-0">
                            <div class="row mx-0">
                              <div class="col-12 ps-0 py-1 text-start">
                                <div class="heading ft-16">
                                  {{average[0]}}
                                </div>
                              </div>
                              <div class="col-6 px-0 py-1">
                                <div class="row mx-0">
                                  <div
                                    class="col-5 px-0 ft-14 text-secondary text-start">
                                    Buy Avg:
                                  </div>
                                  <div
                                    class="col-7 px-0 ft-14 text-darkgrey text-start">
                                    {{average[3]}}
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 px-0 py-1">
                                <div class="row mx-0">
                                  <div
                                    class="col-6 px-0 ft-14 text-secondary text-start">
                                    Buy Date:
                                  </div>
                                  <div
                                    class="col-6 px-0 ft-14 text-darkgrey text-end">
                                    {{average[2]}}
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 px-0 py-1">
                                <div class="row mx-0">
                                  <div
                                    class="col-5 px-0 ft-14 text-secondary text-start">
                                    Qty :
                                  </div>
                                  <div
                                    class="col-7 px-0 ft-14 text-darkgrey text-start">
                                    {{average[1]}}
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 px-0 py-1">
                                <div class="row mx-0">
                                  <div
                                    class="col-6 px-0 ft-14 text-secondary text-start">
                                    Buy Value:
                                  </div>
                                  <div
                                    class="col-6 px-0 ft-14 text-darkgrey text-end">
                                    {{average[4]}}
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 px-0 py-1">
                                <div class="row mx-0">
                                  <div
                                    class="col-6 px-0 ft-14 text-secondary text-start">
                                    Sell Value:
                                  </div>
                                  <div
                                    class="col-6 px-0 ft-14 text-darkgrey text-start">
                                    {{average[7]}}
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 px-0 py-1">
                                <div class="row mx-0">
                                  <div
                                    class="col-6 px-0 ft-14 text-secondary text-start">
                                    Sell Date:
                                  </div>
                                  <div
                                    class="col-6 px-0 ft-14 text-darkgrey text-end">
                                    {{average[5]}}
                                  </div>
                                </div>
                              </div>
                              <div class="col-6 px-0 py-1">
                                <div class="row mx-0">
                                  <div
                                    class="col-5 px-0 ft-14 text-secondary text-start">
                                    Sell Avg:
                                  </div>
                                  <div
                                    class="col-7 px-0 ft-14 text-darkgrey text-start">
                                    {{average[6]}}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div> -->
                </div>
                @if (equityrow.length == 0) {
                  <div class="img-block py-5 text-center">
                    <div class="pt-5">
                      <img src="./assets/images/data-not-fnd.png" alt="data not found"
                        class="" width="240">
                      </div>
                      <div class="p-4">
                        <p class="fw-normal">Data not found</p>
                      </div>
                    </div>
                  }
                  @if (anoSearchResults) {
                    <div class="text-center">
                      <div class="img-block py-5 text-center">
                        <div class="pt-5">
                          <img src="./assets/images/data-not-fnd.png" alt="data not found"
                            class="" width="240">
                          </div>
                          <div class="p-4">
                            <p class="fw-normal">Data not found</p>
                          </div>
                        </div>
                      </div>
                    }
                    <!--Pagination-->
                    <!-- <nav *ngIf="equityrow.length > 0"
                    aria-label="Page navigation nav-cus example">
                    <ul class="pagination justify-content-end">
                      <li class="page-item" [class.disabled]="acurrentPagee === 1">
                        <a class="page-link" (click)="achangePage(-1)">
                          <span class="move-l-r">
                            <i class="bi bi-chevron-left"></i>
                            <i class="bi bi-chevron-left"></i>
                          </span>
                        Previous</a>
                      </li>
                      <ng-container *ngFor="let apageNumber of avisiblePageNumbers">
                        <li class="page-item"
                          [class.active]="apageNumber === acurrentPagee">
                          <a class="page-link" (click)="achangePage(apageNumber)">{{
                          apageNumber }}</a>
                        </li>
                      </ng-container>
                      <li class="page-item"
                        [class.disabled]="acurrentPagee === atotalPages">
                        <a class="page-link" (click)="achangePage(1)">
                          Next
                          <span class="move-r-r">
                            <i class="bi bi-chevron-right"></i>
                            <i class="bi bi-chevron-right"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </nav> -->
                  @if (!anoSearchResults && equityrow.length > 0) {
                    <nav
                      aria-label="Page navigation nav-cus example">
                      <ul class="pagination justify-content-end">
                        <li class="page-item" [class.disabled]="acurrentPagee === 1">
                          <a class="page-link" (click)="achangePagep(-1)">
                            <span class="move-l-r">
                              <i class="bi bi-chevron-left"></i>
                              <i class="bi bi-chevron-left"></i>
                            </span>
                            Previous
                          </a>
                        </li>
                        @if (acurrentPagee > 3) {
                          <li class="page-item">
                            <a class="page-link" (click)="achangePage(1)">1</a>
                          </li>
                        }
                        @if (acurrentPagee > 4) {
                          <li class="page-item">
                            <span class="page-link">...</span>
                          </li>
                        }
                        @for (apageNumber of avisiblePageNumbers; track apageNumber) {
                          <li class="page-item"
                            [class.active]="apageNumber === acurrentPagee">
                            <a class="page-link"
                            (click)="achangePage(apageNumber)">{{apageNumber }}</a>
                          </li>
                        }
                        @if (acurrentPagee < atotalPages - 3) {
                          <li class="page-item">
                            <span class="page-link">...</span>
                          </li>
                        }
                        @if (acurrentPagee < atotalPages - 2) {
                          <li class="page-item">
                            <a class="page-link" (click)="achangePage(atotalPages)"> {{
                            atotalPages }}</a>
                          </li>
                        }
                        <li class="page-item"
                          [class.disabled]="acurrentPagee === atotalPages">
                          <a class="page-link" (click)="achangePagen(1)">
                            Next
                            <span class="move-r-r">
                              <i class="bi bi-chevron-right"></i>
                              <i class="bi bi-chevron-right"></i>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  }
                </div>
              }
            </ng-template>
          </li>
        }
        @if (fno) {
          <li [ngbNavItem]="1">
            <p class="tex-center">
              @if (fno) {
                <a ngbNavLink class="px-5 mr-4 border fnomob mb-2"
                  (click)="submitProfitNLoss(segments[1])">
                  <span class="p-2">
                    <span class="text-secondary ft-14 text-center">
                      {{fnoname}}
                    </span>
                    <br>
                      <p class="text-center cus-pad">
                        <span [ngClass]="fnotable < 0 ? 'text-danger' : 'text-success'">
                          ₹ {{fnotable |number:'1.0-3'}}
                        </span>
                      </p>
                    </span>
                  </a>
                }
              </p>
              <ng-template ngbNavContent>
                <!--Search Field-->
                @if (displayTrades == 'true' && fnorow.length > 0 || searchTextB && searchTextB !== '') {
                  <div class="row mt-3 mb-0"
                    >
                    <!-- *ngIf="fnorow.length > 0 || (searchTextB && searchTextB !== '')" -->
                    <div class="col-md-10 col-6"></div>
                    <div class="col-md-2 col-6">
                      <input class="form-control ft-12" type="text"
                        (input)="applyFilterB($event)" id="searchInputB" autocomplete="off"
                        #searchInputB placeholder="Search" />
                      </div>
                    </div>
                  }
                  @if (fnorow) {
                    <div class="pt-3 mobile-padding">
                      @if (!noSearchResults && fnorow.length > 0) {
                        <div class="table">
                          <div class="table-inner hide-mobile">
                            <table class="table-cus1">
                              <tr class="border-top text-start">
                                <!-- <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                *ngFor="let header of fnoheader">{{getheader(header)
                              |titlecase}}</th> -->
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2" sortable="0"
                                (click)="fnoTableSorting(0)"
                                (mouseenter)="currentHoveredColumn = '0'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-2"></div>
                                  <div class="col-8 text-center">
                                    <span>Symbol</span>
                                  </div>
                                  <div class="col-2">
                                    @if (SortingDirections[0] !== 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                      <span
                                        ><img
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[0] === 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                      <span
                                        ><img
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                sortable="1"
                                (click)="fnoTableSorting(1)"
                                (mouseenter)="currentHoveredColumn = '1'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-12 text-center">
                                    <span>Quantity</span>
                                    @if (SortingDirections[1] !== 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[1] === 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                sortable="2"
                                (click)="fnoTableSorting(2)"
                                (mouseenter)="currentHoveredColumn = '2'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-12 text-center">
                                    <span>Buy Date</span>
                                    @if (SortingDirections[2] !== 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[2] === 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                sortable="3"
                                (click)="fnoTableSorting(3)"
                                (mouseenter)="currentHoveredColumn = '3'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-12 text-center">
                                    <span>Buy Average</span>
                                    @if (SortingDirections[3] !== 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[3] === 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                sortable="4"
                                (click)="fnoTableSorting(4)"
                                (mouseenter)="currentHoveredColumn = '4'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-12 text-center">
                                    <span>Buy Value</span>
                                    @if (SortingDirections[4] !== 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[4] === 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                sortable="5"
                                (click)="fnoTableSorting(5)"
                                (mouseenter)="currentHoveredColumn = '5'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-12 text-center">
                                    <span>Sell Date</span>
                                    @if (SortingDirections[5] !== 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[5] === 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                sortable="6"
                                (click)="fnoTableSorting(6)"
                                (mouseenter)="currentHoveredColumn = '6'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-12 text-center">
                                    <span>Sell Average</span>
                                    @if (SortingDirections[6] !== 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[6] === 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                sortable="7"
                                (click)="fnoTableSorting(7)"
                                (mouseenter)="currentHoveredColumn = '7'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-12 text-center">
                                    <span>Sell Value</span>
                                    @if (SortingDirections[7] !== 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[7] === 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                              <th scope="col"
                                class="text-center cursor-pointer text-secondary border-end col-2"
                                sortable="8"
                                (click)="fnoTableSorting(8)"
                                (mouseenter)="currentHoveredColumn = '8'"
                                (mouseleave)="currentHoveredColumn = null">
                                <div class="row">
                                  <div class="col-12 text-center">
                                    <span>Profit / Loss</span>
                                    @if (SortingDirections[8] !== 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-up.png" alt=""
                                      width="10"></span>
                                    }
                                    @if (SortingDirections[8] === 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                      <span
                                        ><img style="position: absolute;top: 8px;right: 2px;"
                                        src="./assets/images/arrow-down.png" alt=""
                                      width="10"></span>
                                    }
                                  </div>
                                </div>
                              </th>
                            </tr>
                            @for (average of fnorowData; track average) {
                              <tr
                                class="shadow-none table-row">
                                <td id="data1" class="border-end col-2 text-center">
                                  {{average[0]}}
                                </td>
                                <td class="border-end col-2 text-center"> {{average[1]}}
                                </td>
                                <td class="border-end col-2 text-center"> {{average[2]}}
                                </td>
                                <td class="border-end col-2 text-center"> {{average[3]}}
                                </td>
                                <td class="border-end col-2 text-center"> {{average[4]}}
                                </td>
                                <td class="border-end col-2 text-center"> {{average[5]}}
                                </td>
                                <td class="border-end col-2 text-center"> {{average[6]}}
                                </td>
                                <td class="border-end col-2 text-center"> {{average[7]}}
                                </td>
                                <td class="border-end col-2 text-center"
                                  [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                {{average[8]}}</td>
                              </tr>
                            }
                          </table>
                        </div>
                        <div class="show-mobile">
                          <div class="py-2 overflow-height">
                            @for (average of fnorowData; track average) {
                              <div class="card rounded-0 py-2 ps-0 border-0 border-bottom"
                                >
                                <div class="card-inner px-2 ps-0">
                                  <div class="row mx-0">
                                    <div class="col-12 ps-0 py-1 text-start">
                                      <div class="heading ft-16">
                                        {{average[0]}}
                                      </div>
                                    </div>
                                    <!-- <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div class="col-4 px-0 ft-14 text-secondary text-start">
                                        ISIN :
                                      </div>
                                      <div class="col-8 px-0 ft-14 text-darkgrey text-start">
                                        {{average[1]}}
                                      </div>
                                    </div>
                                  </div> -->
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-5 px-0 ft-14 text-secondary text-start">
                                        Buy Avg:
                                      </div>
                                      <div
                                        class="col-7 px-0 ft-14 text-darkgrey text-start">
                                        {{average[3]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-6 px-0 ft-14 text-secondary text-start">
                                        Buy Date:
                                      </div>
                                      <div
                                        class="col-6 px-0 ft-14 text-darkgrey text-end">
                                        {{average[2]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-5 px-0 ft-14 text-secondary text-start">
                                        Qty :
                                      </div>
                                      <div
                                        class="col-7 px-0 ft-14 text-darkgrey text-start">
                                        {{average[1]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-6 px-0 ft-14 text-secondary text-start">
                                        Buy Value:
                                      </div>
                                      <div
                                        class="col-6 px-0 ft-14 text-darkgrey text-end">
                                        {{average[4]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-6 px-0 ft-14 text-secondary text-start">
                                        Sell Value:
                                      </div>
                                      <div
                                        class="col-6 px-0 ft-14 text-darkgrey text-start">
                                        {{average[7]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-6 px-0 ft-14 text-secondary text-start">
                                        Sell Date:
                                      </div>
                                      <div
                                        class="col-6 px-0 ft-14 text-darkgrey text-end">
                                        {{average[5]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-5 px-0 ft-14 text-secondary text-start">
                                        Sell Avg:
                                      </div>
                                      <div
                                        class="col-7 px-0 ft-14 text-darkgrey text-start">
                                        {{average[6]}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-6 px-0 py-1">
                                    <div class="row mx-0">
                                      <div
                                        class="col-5 px-0 ft-14 text-secondary text-start">
                                        Profit :
                                      </div>
                                      <div class="col-7 px-0 ft-14 text-darkgrey text-start"
                                        [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                        {{average[8]}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (fnorow.length == 0) {
                    <div class="img-block py-5 text-center">
                      <div class="pt-5">
                        <img src="./assets/images/data-not-fnd.png" alt="data not found"
                          class="" width="240">
                        </div>
                        <div class="p-4">
                          <p class="fw-normal">Data not found</p>
                        </div>
                      </div>
                    }
                    @if (noSearchResults) {
                      <div class="text-center">
                        <div class="img-block py-5 text-center">
                          <div class="pt-5">
                            <img src="./assets/images/data-not-fnd.png" alt="data not found"
                              class="" width="240">
                            </div>
                            <div class="p-4">
                              <p class="fw-normal">Data not found</p>
                            </div>
                          </div>
                        </div>
                      }
                      <!--Pagination-->
                      @if (!noSearchResults && fnorow.length > 0) {
                        <nav
                          aria-label="Page navigation nav-cus example">
                          <ul class="pagination justify-content-end">
                            <li class="page-item" [class.disabled]="currentPagee === 1">
                              <a class="page-link" (click)="changePagep(-1)">
                                <span class="move-l-r">
                                  <i class="bi bi-chevron-left"></i>
                                  <i class="bi bi-chevron-left"></i>
                                </span>
                                Previous
                              </a>
                            </li>
                            @if (currentPagee > 3) {
                              <li class="page-item">
                                <a class="page-link" (click)="changePage(1)">1</a>
                              </li>
                            }
                            @if (currentPagee > 4) {
                              <li class="page-item">
                                <span class="page-link">...</span>
                              </li>
                            }
                            @for (pageNumber of visiblePageNumbers; track pageNumber) {
                              <li class="page-item"
                                [class.active]="pageNumber === currentPagee">
                                <a class="page-link" (click)="changePage(pageNumber)">{{
                                pageNumber }}</a>
                              </li>
                            }
                            @if (currentPagee < totalPages - 3) {
                              <li class="page-item">
                                <span class="page-link">...</span>
                              </li>
                            }
                            @if (currentPagee < totalPages - 2) {
                              <li class="page-item">
                                <a class="page-link" (click)="changePage(totalPages)"> {{
                                totalPages }}</a>
                              </li>
                            }
                            <li class="page-item"
                              [class.disabled]="currentPagee === totalPages">
                              <a class="page-link" (click)="changePagen(1)">
                                Next
                                <span class="move-r-r">
                                  <i class="bi bi-chevron-right"></i>
                                  <i class="bi bi-chevron-right"></i>
                                </span>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      }
                    </div>
                  }
                </ng-template>
              </li>
            }
            <li [ngbNavItem]="2">
              <p class="tex-center">
                @if (com) {
                  <a ngbNavLink class="px-5 mr-4 border mb-2 cmdymob"
                    (click)="submitProfitNLoss(segments[2])">
                    <span class="p-2">
                      <span class="text-secondary ft-14 text-center">
                        {{comname}}
                      </span>
                      <br>
                        <p class="text-center cus-pad">
                          <span [ngClass]="comtable < 0 ? 'text-danger' : 'text-success'">
                            ₹ {{comtable |number:'1.0-3'}}
                          </span>
                        </p>
                      </span>
                    </a>
                  }
                </p>
                <ng-template ngbNavContent>
                  <!--Search Field-->
                  @if (displayTrades == 'true' && comrow.length > 0 || searchTextC && searchTextC !== '') {
                    <div class="row mt-3 mb-0"
                      >
                      <!--*ngIf="comrow.length > 0 || (searchTextC && searchTextC !== '')"-->
                      <div class="col-md-10 col-6"></div>
                      <div class="col-md-2 col-6">
                        <input class="form-control ft-12" type="text"
                          (input)="applyFilterC($event)" id="searchInputC" autocomplete="off"
                          #searchInputC placeholder="Search" />
                        </div>
                      </div>
                    }
                    @if (comrow) {
                      <div class="pt-3 mobile-padding">
                        @if (!cnoSearchResults && comrow.length > 0) {
                          <div class="table">
                            <div class="table-inner hide-mobile">
                              <table class="table-cus1">
                                <tr class="border-top text-start">
                                  <!-- <th scope="col"
                                  class="text-center text-secondary border-end col-2"
                                  *ngFor="let header of comheader">{{getheader(header)
                                |titlecase}}</th> -->
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2" sortable="0"
                                  (click)="comrowTableSorting(0)"
                                  (mouseenter)="currentHoveredColumn = '0'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-2"></div>
                                    <div class="col-8 text-center">
                                      <span>Symbol</span>
                                    </div>
                                    <div class="col-2">
                                      @if (SortingDirections[0] !== 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                        <span
                                          ><img
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[0] === 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                        <span
                                          ><img
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2"
                                  sortable="1"
                                  (click)="comrowTableSorting(1)"
                                  (mouseenter)="currentHoveredColumn = '1'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-12 text-center">
                                      <span>Quantity</span>
                                      @if (SortingDirections[1] !== 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[1] === 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2"
                                  sortable="2"
                                  (click)="comrowTableSorting(2)"
                                  (mouseenter)="currentHoveredColumn = '2'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-12 text-center">
                                      <span>Buy Date</span>
                                      @if (SortingDirections[2] !== 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[2] === 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2"
                                  sortable="3"
                                  (click)="comrowTableSorting(3)"
                                  (mouseenter)="currentHoveredColumn = '3'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-12 text-center">
                                      <span>Buy Average</span>
                                      @if (SortingDirections[3] !== 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[3] === 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2"
                                  sortable="4"
                                  (click)="comrowTableSorting(4)"
                                  (mouseenter)="currentHoveredColumn = '4'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-12 text-center">
                                      <span>Buy Value</span>
                                      @if (SortingDirections[4] !== 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[4] === 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2"
                                  sortable="5"
                                  (click)="comrowTableSorting(5)"
                                  (mouseenter)="currentHoveredColumn = '5'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-12 text-center">
                                      <span>Sell Date</span>
                                      @if (SortingDirections[5] !== 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[5] === 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2"
                                  sortable="6"
                                  (click)="comrowTableSorting(6)"
                                  (mouseenter)="currentHoveredColumn = '6'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-12 text-center">
                                      <span>Sell Average</span>
                                      @if (SortingDirections[6] !== 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[6] === 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2"
                                  sortable="7"
                                  (click)="comrowTableSorting(7)"
                                  (mouseenter)="currentHoveredColumn = '7'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-12 text-center">
                                      <span>Sell Value</span>
                                      @if (SortingDirections[7] !== 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[7] === 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                                <th scope="col"
                                  class="text-center cursor-pointer text-secondary border-end col-2"
                                  sortable="8"
                                  (click)="comrowTableSorting(8)"
                                  (mouseenter)="currentHoveredColumn = '8'"
                                  (mouseleave)="currentHoveredColumn = null">
                                  <div class="row">
                                    <div class="col-12 text-center">
                                      <span>Profit / Loss</span>
                                      @if (SortingDirections[8] !== 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-up.png" alt=""
                                        width="10"></span>
                                      }
                                      @if (SortingDirections[8] === 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                        <span
                                          ><img style="position: absolute;top: 8px;right: 2px;"
                                          src="./assets/images/arrow-down.png" alt=""
                                        width="10"></span>
                                      }
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              @for (average of comrowData; track average) {
                                <tr
                                  class="shadow-none table-row">
                                  <td class="border-end col-2 text-center">{{average[0]}}
                                  </td>
                                  <td class="border-end col-2 text-center"> {{average[1]}}
                                  </td>
                                  <td class="border-end col-2 text-center"> {{average[2]}}
                                  </td>
                                  <td class="border-end col-2 text-center"> {{average[3]}}
                                  </td>
                                  <td class="border-end col-2 text-center"> {{average[4]}}
                                  </td>
                                  <td class="border-end col-2 text-center"> {{average[5]}}
                                  </td>
                                  <td class="border-end col-2 text-center"> {{average[6]}}
                                  </td>
                                  <td class="border-end col-2 text-center"> {{average[7]}}
                                  </td>
                                  <td class="border-end col-2 text-center"
                                    [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                  {{average[8]}}</td>
                                </tr>
                              }
                            </table>
                          </div>
                          <div class="show-mobile">
                            <div class="py-2 overflow-height">
                              @for (average of comrowData; track average) {
                                <div class="card rounded-0 py-2 ps-0 border-0 border-bottom"
                                  >
                                  <div class="card-inner px-2 ps-0">
                                    <div class="row mx-0">
                                      <div class="col-12 ps-0 py-1 text-start">
                                        <div class="heading ft-16">
                                          {{average[0]}}
                                        </div>
                                      </div>
                                      <!-- <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div class="col-4 px-0 ft-14 text-secondary text-start">
                                          ISIN :
                                        </div>
                                        <div class="col-8 px-0 ft-14 text-darkgrey text-start">
                                          {{average[1]}}
                                        </div>
                                      </div>
                                    </div> -->
                                    <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div
                                          class="col-5 px-0 ft-14 text-secondary text-start">
                                          Buy Avg:
                                        </div>
                                        <div
                                          class="col-7 px-0 ft-14 text-darkgrey text-start">
                                          {{average[3]}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div
                                          class="col-6 px-0 ft-14 text-secondary text-start">
                                          Buy Date:
                                        </div>
                                        <div
                                          class="col-6 px-0 ft-14 text-darkgrey text-end">
                                          {{average[2]}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div
                                          class="col-5 px-0 ft-14 text-secondary text-start">
                                          Qty :
                                        </div>
                                        <div
                                          class="col-7 px-0 ft-14 text-darkgrey text-start">
                                          {{average[1]}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div
                                          class="col-6 px-0 ft-14 text-secondary text-start">
                                          Buy Value:
                                        </div>
                                        <div
                                          class="col-6 px-0 ft-14 text-darkgrey text-end">
                                          {{average[4]}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div
                                          class="col-6 px-0 ft-14 text-secondary text-start">
                                          Sell Value:
                                        </div>
                                        <div
                                          class="col-6 px-0 ft-14 text-darkgrey text-start">
                                          {{average[7]}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div
                                          class="col-6 px-0 ft-14 text-secondary text-start">
                                          Sell Date:
                                        </div>
                                        <div
                                          class="col-6 px-0 ft-14 text-darkgrey text-end">
                                          {{average[5]}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div
                                          class="col-5 px-0 ft-14 text-secondary text-start">
                                          Sell Avg:
                                        </div>
                                        <div
                                          class="col-7 px-0 ft-14 text-darkgrey text-start">
                                          {{average[6]}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-6 px-0 py-1">
                                      <div class="row mx-0">
                                        <div
                                          class="col-5 px-0 ft-14 text-secondary text-start">
                                          Profit:
                                        </div>
                                        <div class="col-7 px-0 ft-14 text-darkgrey text-end"
                                          [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                          {{average[8]}}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    @if (comrow.length == 0) {
                      <div class="img-block py-5 text-center">
                        <div class="pt-5">
                          <img src="./assets/images/data-not-fnd.png" alt="data not found"
                            class="" width="240">
                          </div>
                          <div class="p-4">
                            <p class="fw-normal">Data not found</p>
                          </div>
                        </div>
                      }
                      @if (cnoSearchResults) {
                        <div class="text-center">
                          <div class="img-block py-5 text-center">
                            <div class="pt-5">
                              <img src="./assets/images/data-not-fnd.png" alt="data not found"
                                class="" width="240">
                              </div>
                              <div class="p-4">
                                <p class="fw-normal">Data not found</p>
                              </div>
                            </div>
                          </div>
                        }
                        <!--Pagination-->
                        @if ( !cnoSearchResults && comrow.length > 0) {
                          <nav
                            aria-label="Page navigation nav-cus example">
                            <ul class="pagination justify-content-end">
                              <li class="page-item" [class.disabled]="bcurrentPagee === 1">
                                <a class="page-link" (click)="bchangePagep(-1)">
                                  <span class="move-l-r">
                                    <i class="bi bi-chevron-left"></i>
                                    <i class="bi bi-chevron-left"></i>
                                  </span>
                                  Previous
                                </a>
                              </li>
                              @if (bcurrentPagee > 3) {
                                <li class="page-item">
                                  <a class="page-link" (click)="bchangePage(1)">1</a>
                                </li>
                              }
                              @if (bcurrentPagee > 4) {
                                <li class="page-item">
                                  <span class="page-link">...</span>
                                </li>
                              }
                              @for (bpageNumber of bvisiblePageNumbers; track bpageNumber) {
                                <li class="page-item"
                                  [class.active]="bpageNumber === bcurrentPagee">
                                  <a class="page-link"
                                  (click)="bchangePage(bpageNumber)">{{bpageNumber }}</a>
                                </li>
                              }
                              @if (bcurrentPagee < btotalPages - 3) {
                                <li class="page-item">
                                  <span class="page-link">...</span>
                                </li>
                              }
                              @if (bcurrentPagee < btotalPages - 2) {
                                <li class="page-item">
                                  <a class="page-link" (click)="bchangePage(btotalPages)"> {{
                                  btotalPages }}</a>
                                </li>
                              }
                              <li class="page-item"
                                [class.disabled]="bcurrentPagee === btotalPages">
                                <a class="page-link" (click)="bchangePagen(1)">
                                  Next
                                  <span class="move-r-r">
                                    <i class="bi bi-chevron-right"></i>
                                    <i class="bi bi-chevron-right"></i>
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </nav>
                        }
                      </div>
                    }
                  </ng-template>
                </li>
                <li [ngbNavItem]="3">
                  <p class="tex-center">
                    @if (cur) {
                      <a ngbNavLink class="px-5 mr-4 border text-center mb-2"
                        (click)="submitProfitNLoss(segments[3])">
                        <span class="p-2">
                          <span class="text-secondary ft-14">
                            {{curname}}
                          </span>
                          <br>
                            <p class="text-center cus-pad">
                              <span [ngClass]="curtable < 0 ? 'text-danger' : 'text-success'">
                                ₹ {{curtable |number:'1.0-3'}}
                              </span>
                            </p>
                          </span>
                        </a>
                      }
                    </p>
                    <ng-template ngbNavContent>
                      <!-- Search Field -->
                      <!-- <div class="row mt-3 mb-0" *ngIf="currow.length > 0 || (searchTextD && searchTextD !== '')"
                      > -->
                      @if (displayTrades == 'true' && currow.length > 0 || searchTextD && searchTextD !== '') {
                        <div class="row mt-3 mb-0"
                          >
                          <!--*ngIf="currow.length > 0 || (searchTextD && searchTextD !== '')"-->
                          <div class="col-md-10 col-6"></div>
                          <div class="col-md-2 col-6">
                            <input class="form-control ft-12" type="text"
                              (input)="applyFilterD($event)" id="searchInputD" autocomplete="off"
                              #searchInputD placeholder="Search" />
                            </div>
                          </div>
                        }
                        @if (currow) {
                          <div class="pt-3 mobile-padding">
                            @if (!dnoSearchResults && currow.length > 0) {
                              <div class="table">
                                <div class="table-inner hide-mobile">
                                  <table class="table-cus1">
                                    <tr class="border-top text-start">
                                      <!-- <th scope="col"
                                      class="text-center text-secondary border-end col-2"
                                      *ngFor="let header of curheader">{{getheader(header)
                                    |titlecase}}</th> -->
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2" sortable="0"
                                      (click)="currowTableSorting(0)"
                                      (mouseenter)="currentHoveredColumn = '0'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-2"></div>
                                        <div class="col-8 text-center">
                                          <span>Symbol</span>
                                        </div>
                                        <div class="col-2">
                                          @if (SortingDirections[0] !== 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                            <span
                                              ><img
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[0] === 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                            <span
                                              ><img
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2"
                                      sortable="1"
                                      (click)="currowTableSorting(1)"
                                      (mouseenter)="currentHoveredColumn = '1'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          <span>Quantity</span>
                                          @if (SortingDirections[1] !== 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[1] === 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2"
                                      sortable="2"
                                      (click)="currowTableSorting(2)"
                                      (mouseenter)="currentHoveredColumn = '2'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          <span>Buy Date</span>
                                          @if (SortingDirections[2] !== 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[2] === 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2"
                                      sortable="3"
                                      (click)="currowTableSorting(3)"
                                      (mouseenter)="currentHoveredColumn = '3'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          <span>Buy Average</span>
                                          @if (SortingDirections[3] !== 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[3] === 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2"
                                      sortable="4"
                                      (click)="currowTableSorting(4)"
                                      (mouseenter)="currentHoveredColumn = '4'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          <span>Buy Value</span>
                                          @if (SortingDirections[4] !== 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[4] === 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2"
                                      sortable="5"
                                      (click)="currowTableSorting(5)"
                                      (mouseenter)="currentHoveredColumn = '5'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          <span>Sell Date</span>
                                          @if (SortingDirections[5] !== 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[5] === 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2"
                                      sortable="6"
                                      (click)="currowTableSorting(6)"
                                      (mouseenter)="currentHoveredColumn = '6'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          <span>Sell Average</span>
                                          @if (SortingDirections[6] !== 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[6] === 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2"
                                      sortable="7"
                                      (click)="currowTableSorting(7)"
                                      (mouseenter)="currentHoveredColumn = '7'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          <span>Sell Value</span>
                                          @if (SortingDirections[7] !== 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[7] === 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                    <th scope="col"
                                      class="text-center cursor-pointer text-secondary border-end col-2"
                                      sortable="8"
                                      (click)="currowTableSorting(8)"
                                      (mouseenter)="currentHoveredColumn = '8'"
                                      (mouseleave)="currentHoveredColumn = null">
                                      <div class="row">
                                        <div class="col-12 text-center">
                                          <span>Profit / Loss</span>
                                          @if (SortingDirections[8] !== 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-up.png" alt=""
                                            width="10"></span>
                                          }
                                          @if (SortingDirections[8] === 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                            <span
                                              ><img style="position: absolute;top: 8px;right: 2px;"
                                              src="./assets/images/arrow-down.png" alt=""
                                            width="10"></span>
                                          }
                                        </div>
                                      </div>
                                    </th>
                                  </tr>
                                  @for (average of currowData; track average) {
                                    <tr
                                      class="shadow-none table-row">
                                      <td class="border-end col-2 text-center"> {{average[0]}}
                                      </td>
                                      <td class="border-end col-2 text-center"> {{average[1]}}
                                      </td>
                                      <td class="border-end col-2 text-center"> {{average[2]}}
                                      </td>
                                      <td class="border-end col-2 text-center"> {{average[3]}}
                                      </td>
                                      <td class="border-end col-2 text-center"> {{average[4]}}
                                      </td>
                                      <td class="border-end col-2 text-center"> {{average[5]}}
                                      </td>
                                      <td class="border-end col-2 text-center"> {{average[6]}}
                                      </td>
                                      <td class="border-end col-2 text-center"> {{average[7]}}
                                      </td>
                                      <td class="border-end col-2 text-center"
                                        [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                      {{average[8]}}</td>
                                    </tr>
                                  }
                                </table>
                              </div>
                              <div class="show-mobile">
                                <div class="py-2 overflow-height">
                                  @for (average of currowData; track average) {
                                    <div class="card rounded-0 py-2 ps-0 border-0 border-bottom"
                                      >
                                      <div class="card-inner px-2 ps-0">
                                        <div class="row mx-0">
                                          <div class="col-12 ps-0 py-1 text-start">
                                            <div class="heading ft-16">
                                              {{average[0]}}
                                            </div>
                                          </div>
                                          <!-- <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div class="col-4 px-0 ft-14 text-secondary text-start">
                                              ISIN :
                                            </div>
                                            <div class="col-8 px-0 ft-14 text-darkgrey text-start">
                                              {{average[1]}}
                                            </div>
                                          </div>
                                        </div> -->
                                        <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div
                                              class="col-5 px-0 ft-14 text-secondary text-start">
                                              Buy Avg:
                                            </div>
                                            <div
                                              class="col-7 px-0 ft-14 text-darkgrey text-start">
                                              {{average[3]}}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div
                                              class="col-6 px-0 ft-14 text-secondary text-start">
                                              Buy Date:
                                            </div>
                                            <div
                                              class="col-6 px-0 ft-14 text-darkgrey text-end">
                                              {{average[2]}}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div
                                              class="col-5 px-0 ft-14 text-secondary text-start">
                                              Qty :
                                            </div>
                                            <div
                                              class="col-7 px-0 ft-14 text-darkgrey text-start">
                                              {{average[1]}}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div
                                              class="col-6 px-0 ft-14 text-secondary text-start">
                                              Buy Value:
                                            </div>
                                            <div
                                              class="col-6 px-0 ft-14 text-darkgrey text-end">
                                              {{average[4]}}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div
                                              class="col-6 px-0 ft-14 text-secondary text-start">
                                              Sell Value:
                                            </div>
                                            <div
                                              class="col-6 px-0 ft-14 text-darkgrey text-start">
                                              {{average[7]}}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div
                                              class="col-6 px-0 ft-14 text-secondary text-start">
                                              Sell Date:
                                            </div>
                                            <div
                                              class="col-6 px-0 ft-14 text-darkgrey text-end">
                                              {{average[5]}}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div
                                              class="col-5 px-0 ft-14 text-secondary text-start">
                                              Sell Avg:
                                            </div>
                                            <div
                                              class="col-7 px-0 ft-14 text-darkgrey text-start">
                                              {{average[6]}}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-6 px-0 py-1">
                                          <div class="row mx-0">
                                            <div
                                              class="col-5 px-0 ft-14 text-secondary text-start">
                                              Profit:
                                            </div>
                                            <div class="col-7 px-0 ft-14 text-darkgrey text-end"
                                              [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                              {{average[8]}}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                        @if (currow.length == 0) {
                          <div class="img-block py-5 text-center">
                            <div class="pt-5">
                              <img src="./assets/images/data-not-fnd.png" alt="data not found"
                                class="" width="240">
                              </div>
                              <div class="p-4">
                                <p class="fw-normal">Data not found</p>
                              </div>
                            </div>
                          }
                          @if (dnoSearchResults) {
                            <div class="text-center">
                              <div class="img-block py-5 text-center">
                                <div class="pt-5">
                                  <img src="./assets/images/data-not-fnd.png" alt="data not found"
                                    class="" width="240">
                                  </div>
                                  <div class="p-4">
                                    <p class="fw-normal">Data not found</p>
                                  </div>
                                </div>
                              </div>
                            }
                            <!--Pagination-->
                            <!-- <nav *ngIf="currow.length > 0" aria-label="Page navigation nav-cus example">
                            <ul class="pagination justify-content-end">
                              <li class="page-item" [class.disabled]="ccurrentPagee === 1">
                                <a class="page-link" (click)="cchangePage(-1)">
                                  <span class="move-l-r">
                                    <i class="bi bi-chevron-left "></i>
                                    <i class="bi bi-chevron-left "></i>
                                  </span>
                                Previous</a>
                              </li>
                              <ng-container *ngFor="let cpageNumber of cvisiblePageNumbers">
                                <li class="page-item"
                                  [class.active]="cpageNumber === ccurrentPagee">
                                  <a class="page-link" (click)="cchangePage(cpageNumber)">{{
                                  cpageNumber }}</a>
                                </li>
                              </ng-container>
                              <li class="page-item"
                                [class.disabled]="ccurrentPagee === ctotalPages">
                                <a class="page-link" (click)="cchangePage(1)">
                                  Next
                                  <span class="move-r-r">
                                    <i class="bi bi-chevron-right"></i>
                                    <i class="bi bi-chevron-right"></i>
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </nav> -->
                          @if (!dnoSearchResults && currow.length > 0) {
                            <nav
                              aria-label="Page navigation nav-cus example">
                              <ul class="pagination justify-content-end">
                                <li class="page-item" [class.disabled]="ccurrentPagee === 1">
                                  <a class="page-link" (click)="cchangePagep(-1)">
                                    <span class="move-l-r">
                                      <i class="bi bi-chevron-left"></i>
                                      <i class="bi bi-chevron-left"></i>
                                    </span>
                                    Previous
                                  </a>
                                </li>
                                @if (ccurrentPagee > 3) {
                                  <li class="page-item">
                                    <a class="page-link" (click)="cchangePage(1)">1</a>
                                  </li>
                                }
                                @if (ccurrentPagee > 4) {
                                  <li class="page-item">
                                    <span class="page-link">...</span>
                                  </li>
                                }
                                @for (cpageNumber of cvisiblePageNumbers; track cpageNumber) {
                                  <li class="page-item"
                                    [class.active]="cpageNumber === ccurrentPagee">
                                    <a class="page-link"
                                    (click)="cchangePage(cpageNumber)">{{cpageNumber }}</a>
                                  </li>
                                }
                                @if (ccurrentPagee < ctotalPages - 3) {
                                  <li class="page-item">
                                    <span class="page-link">...</span>
                                  </li>
                                }
                                @if (ccurrentPagee < ctotalPages - 2) {
                                  <li class="page-item">
                                    <a class="page-link" (click)="cchangePage(ctotalPages)"> {{
                                    ctotalPages }}</a>
                                  </li>
                                }
                                <li class="page-item"
                                  [class.disabled]="ccurrentPagee === ctotalPages">
                                  <a class="page-link" (click)="cchangePagen(1)">
                                    Next
                                    <span class="move-r-r">
                                      <i class="bi bi-chevron-right"></i>
                                      <i class="bi bi-chevron-right"></i>
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </nav>
                          }
                        </div>
                      }
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="4">
                    <p class="tex-center">
                      @if (nse) {
                        <a ngbNavLink class="px-5 mr-4 border text-center mb-2"
                          (click)="submitProfitNLoss(segments[4])">
                          <span class="p-2">
                            <span class="text-secondary ft-14">
                              {{nsename}}
                            </span>
                            <br>
                              <p class="text-center cus-pad">
                                <span [ngClass]="nsetable < 0 ? 'text-danger' : 'text-success'">
                                  ₹ {{nsetable |number:'1.0-3'}}
                                </span>
                              </p>
                            </span>
                          </a>
                        }
                      </p>
                      <ng-template ngbNavContent>
                        <!-- Search Field -->
                        <!-- <div class="row mt-3 mb-0" *ngIf="currow.length > 0 || (searchTextD && searchTextD !== '')"
                        > -->
                        @if (displayTrades == 'true' && nescomrowData.length > 0 || searchTextE && searchTextE !== '') {
                          <div class="row mt-3 mb-0"
                            >
                            <!--*ngIf="currow.length > 0 || (searchTextD && searchTextD !== '')"-->
                            <div class="col-md-10 col-6"></div>
                            <div class="col-md-2 col-6">
                              <input class="form-control ft-12" type="text"
                                (input)="applyFilterD($event)" id="searchInputE" autocomplete="off"
                                #searchInputE placeholder="Search" />
                              </div>
                            </div>
                          }
                          @if (nserow) {
                            <div class="pt-3 mobile-padding">
                              @if (!dnoSearchResults && currow.length > 0) {
                                <div class="table">
                                  <div class="table-inner hide-mobile">
                                    <table class="table-cus1">
                                      <tr class="border-top text-start">
                                        <!-- <th scope="col"
                                        class="text-center text-secondary border-end col-2"
                                        *ngFor="let header of curheader">{{getheader(header)
                                      |titlecase}}</th> -->
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2" sortable="0"
                                        (click)="nsecomrowTableSorting(0)"
                                        (mouseenter)="currentHoveredColumn = '0'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-2"></div>
                                          <div class="col-8 text-center">
                                            <span>Symbol</span>
                                          </div>
                                          <div class="col-2">
                                            @if (SortingDirections[0] !== 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                              <span
                                                ><img
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[0] === 'desc' && (currentSortedColumn === '0' || currentHoveredColumn === '0')) {
                                              <span
                                                ><img
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2"
                                        sortable="1"
                                        (click)="currowTableSorting(1)"
                                        (mouseenter)="currentHoveredColumn = '1'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-12 text-center">
                                            <span>Quantity</span>
                                            @if (SortingDirections[1] !== 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[1] === 'desc' && (currentSortedColumn === '1' || currentHoveredColumn === '1')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2"
                                        sortable="2"
                                        (click)="nsecomrowTableSorting(2)"
                                        (mouseenter)="currentHoveredColumn = '2'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-12 text-center">
                                            <span>Buy Date</span>
                                            @if (SortingDirections[2] !== 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[2] === 'desc' && (currentSortedColumn === '2' || currentHoveredColumn === '2')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2"
                                        sortable="3"
                                        (click)="nsecomrowTableSorting(3)"
                                        (mouseenter)="currentHoveredColumn = '3'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-12 text-center">
                                            <span>Buy Average</span>
                                            @if (SortingDirections[3] !== 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[3] === 'desc' && (currentSortedColumn === '3' || currentHoveredColumn === '3')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2"
                                        sortable="4"
                                        (click)="nsecomrowTableSorting(4)"
                                        (mouseenter)="currentHoveredColumn = '4'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-12 text-center">
                                            <span>Buy Value</span>
                                            @if (SortingDirections[4] !== 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[4] === 'desc' && (currentSortedColumn === '4' || currentHoveredColumn === '4')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2"
                                        sortable="5"
                                        (click)="nsecomrowTableSorting(5)"
                                        (mouseenter)="currentHoveredColumn = '5'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-12 text-center">
                                            <span>Sell Date</span>
                                            @if (SortingDirections[5] !== 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[5] === 'desc' && (currentSortedColumn === '5' || currentHoveredColumn === '5')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2"
                                        sortable="6"
                                        (click)="nsecomrowTableSorting(6)"
                                        (mouseenter)="currentHoveredColumn = '6'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-12 text-center">
                                            <span>Sell Average</span>
                                            @if (SortingDirections[6] !== 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[6] === 'desc' && (currentSortedColumn === '6' || currentHoveredColumn === '6')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2"
                                        sortable="7"
                                        (click)="nsecomrowTableSorting(7)"
                                        (mouseenter)="currentHoveredColumn = '7'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-12 text-center">
                                            <span>Sell Value</span>
                                            @if (SortingDirections[7] !== 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[7] === 'desc' && (currentSortedColumn === '7' || currentHoveredColumn === '7')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                      <th scope="col"
                                        class="text-center cursor-pointer text-secondary border-end col-2"
                                        sortable="8"
                                        (click)="nsecomrowTableSorting(8)"
                                        (mouseenter)="currentHoveredColumn = '8'"
                                        (mouseleave)="currentHoveredColumn = null">
                                        <div class="row">
                                          <div class="col-12 text-center">
                                            <span>Profit / Loss</span>
                                            @if (SortingDirections[8] !== 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-up.png" alt=""
                                              width="10"></span>
                                            }
                                            @if (SortingDirections[8] === 'desc' && (currentSortedColumn === '8' || currentHoveredColumn === '8')) {
                                              <span
                                                ><img style="position: absolute;top: 8px;right: 2px;"
                                                src="./assets/images/arrow-down.png" alt=""
                                              width="10"></span>
                                            }
                                          </div>
                                        </div>
                                      </th>
                                    </tr>
                                    @for (average of nescomrowData; track average) {
                                      <tr
                                        class="shadow-none table-row">
                                        <td class="border-end col-2 text-center"> {{average[0]}}
                                        </td>
                                        <td class="border-end col-2 text-center"> {{average[1]}}
                                        </td>
                                        <td class="border-end col-2 text-center"> {{average[2]}}
                                        </td>
                                        <td class="border-end col-2 text-center"> {{average[3]}}
                                        </td>
                                        <td class="border-end col-2 text-center"> {{average[4]}}
                                        </td>
                                        <td class="border-end col-2 text-center"> {{average[5]}}
                                        </td>
                                        <td class="border-end col-2 text-center"> {{average[6]}}
                                        </td>
                                        <td class="border-end col-2 text-center"> {{average[7]}}
                                        </td>
                                        <td class="border-end col-2 text-center"
                                          [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                        {{average[8]}}</td>
                                      </tr>
                                    }
                                  </table>
                                </div>
                                <div class="show-mobile">
                                  <div class="py-2 overflow-height">
                                    @for (average of nescomrowData; track average) {
                                      <div class="card rounded-0 py-2 ps-0 border-0 border-bottom"
                                        >
                                        <div class="card-inner px-2 ps-0">
                                          <div class="row mx-0">
                                            <div class="col-12 ps-0 py-1 text-start">
                                              <div class="heading ft-16">
                                                {{average[0]}}
                                              </div>
                                            </div>
                                            <div class="col-6 px-0 py-1">
                                              <div class="row mx-0">
                                                <div
                                                  class="col-5 px-0 ft-14 text-secondary text-start">
                                                  Buy Avg:
                                                </div>
                                                <div
                                                  class="col-7 px-0 ft-14 text-darkgrey text-start">
                                                  {{average[3]}}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-6 px-0 py-1">
                                              <div class="row mx-0">
                                                <div
                                                  class="col-6 px-0 ft-14 text-secondary text-start">
                                                  Buy Date:
                                                </div>
                                                <div
                                                  class="col-6 px-0 ft-14 text-darkgrey text-end">
                                                  {{average[2]}}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-6 px-0 py-1">
                                              <div class="row mx-0">
                                                <div
                                                  class="col-5 px-0 ft-14 text-secondary text-start">
                                                  Qty :
                                                </div>
                                                <div
                                                  class="col-7 px-0 ft-14 text-darkgrey text-start">
                                                  {{average[1]}}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-6 px-0 py-1">
                                              <div class="row mx-0">
                                                <div
                                                  class="col-6 px-0 ft-14 text-secondary text-start">
                                                  Buy Value:
                                                </div>
                                                <div
                                                  class="col-6 px-0 ft-14 text-darkgrey text-end">
                                                  {{average[4]}}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-6 px-0 py-1">
                                              <div class="row mx-0">
                                                <div
                                                  class="col-6 px-0 ft-14 text-secondary text-start">
                                                  Sell Value:
                                                </div>
                                                <div
                                                  class="col-6 px-0 ft-14 text-darkgrey text-start">
                                                  {{average[7]}}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-6 px-0 py-1">
                                              <div class="row mx-0">
                                                <div
                                                  class="col-6 px-0 ft-14 text-secondary text-start">
                                                  Sell Date:
                                                </div>
                                                <div
                                                  class="col-6 px-0 ft-14 text-darkgrey text-end">
                                                  {{average[5]}}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-6 px-0 py-1">
                                              <div class="row mx-0">
                                                <div
                                                  class="col-5 px-0 ft-14 text-secondary text-start">
                                                  Sell Avg:
                                                </div>
                                                <div
                                                  class="col-7 px-0 ft-14 text-darkgrey text-start">
                                                  {{average[6]}}
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-6 px-0 py-1">
                                              <div class="row mx-0">
                                                <div
                                                  class="col-5 px-0 ft-14 text-secondary text-start">
                                                  Profit:
                                                </div>
                                                <div class="col-7 px-0 ft-14 text-darkgrey text-end"
                                                  [ngClass]="average[8] < 0 ? 'text-danger' : 'text-success'">
                                                  {{average[8]}}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                            @if (currow.length == 0) {
                              <div class="img-block py-5 text-center">
                                <div class="pt-5">
                                  <img src="./assets/images/data-not-fnd.png" alt="data not found"
                                    class="" width="240">
                                  </div>
                                  <div class="p-4">
                                    <p class="fw-normal">Data not found</p>
                                  </div>
                                </div>
                              }
                              @if (dnoSearchResults) {
                                <div class="text-center">
                                  <div class="img-block py-5 text-center">
                                    <div class="pt-5">
                                      <img src="./assets/images/data-not-fnd.png" alt="data not found"
                                        class="" width="240">
                                      </div>
                                      <div class="p-4">
                                        <p class="fw-normal">Data not found</p>
                                      </div>
                                    </div>
                                  </div>
                                }
                                @if (!dnoSearchResults && currow.length > 0) {
                                  <nav
                                    aria-label="Page navigation nav-cus example">
                                    <ul class="pagination justify-content-end">
                                      <li class="page-item" [class.disabled]="dcurrentPagee === 1">
                                        <a class="page-link" (click)="dchangePagep(-1)">
                                          <span class="move-l-r">
                                            <i class="bi bi-chevron-left"></i>
                                            <i class="bi bi-chevron-left"></i>
                                          </span>
                                          Previous
                                        </a>
                                      </li>
                                      @if (dcurrentPagee > 3) {
                                        <li class="page-item">
                                          <a class="page-link" (click)="dchangePage(1)">1</a>
                                        </li>
                                      }
                                      @if (dcurrentPagee > 4) {
                                        <li class="page-item">
                                          <span class="page-link">...</span>
                                        </li>
                                      }
                                      @for (dpageNumber of dvisiblePageNumbers; track dpageNumber) {
                                        <li class="page-item"
                                          [class.active]="dpageNumber === dcurrentPagee">
                                          <a class="page-link"
                                          (click)="dchangePage(dpageNumber)">{{dpageNumber }}</a>
                                        </li>
                                      }
                                      @if (dcurrentPagee < dtotalPages - 3) {
                                        <li class="page-item">
                                          <span class="page-link">...</span>
                                        </li>
                                      }
                                      @if (dcurrentPagee < dtotalPages - 2) {
                                        <li class="page-item">
                                          <a class="page-link" (click)="dchangePage(dtotalPages)"> {{
                                          dtotalPages }}</a>
                                        </li>
                                      }
                                      <li class="page-item"
                                        [class.disabled]="dcurrentPagee === dtotalPages">
                                        <a class="page-link" (click)="dchangePagen(1)">
                                          Next
                                          <span class="move-r-r">
                                            <i class="bi bi-chevron-right"></i>
                                            <i class="bi bi-chevron-right"></i>
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </nav>
                                }
                              </div>
                            }
                          </ng-template>
                        </li>
                      </ul>
                      <!-- Search Field
                      <div class="row mt-3 mb-0" *ngIf="showSearch">
                        <div class="col-md-10 col-6"></div>
                        <div class="col-md-2 col-6">
                          <input class="form-control ft-12" type="text" (input)="applyFilter($event)" id="searchInput" autocomplete="off" placeholder="Search" />
                        </div>
                      </div> -->
                      <div [ngbNavOutlet]="nav" class="mt-2"></div>
                    </form>
                  </div>
                </div>
              }
              <!-- <div class="py-5 m-auto h-100" *ngIf="datapresent == false">
              <div class="pt-5 text-center">
                <img src="./assets/images/data-not-fnd.png" alt="data not found" width="240">
              </div>
              <div class="p-4 tex-center">
                <p class="fw-normal text-center">Link is expired</p>
              </div>
            </div> -->
            @if (dataNotFound) {
              <div class="py-5 m-auto h-100">
                <div class="pt-5 text-center">
                  <img src="./assets/images/data-not-fnd.png" alt="data not found" width="240">
                </div>
                <div class="p-4 tex-center">
                  <p class="fw-normal text-center">Data not found</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <ngx-loading [show]="loading">Loading...</ngx-loading>